<template>
  <Board />
</template>

<script>
import Board from './components/Board.vue'

export default {
  name: "App",
  components: {
    Board,
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}
</style>
